import {useGetExtensionsInfiniteQuery} from "@/store/extensions.ts";
import {ExtensionCard} from "@/pages/extensions/components/extension-card.tsx";
import {Spinner} from "@/components/ui/spinner.tsx";
import {useRefInfinity} from "@/hooks/useRefInfinty.ts";
import {cn} from "@/lib/utils.ts";

export function SubExtensions({main, hasSubExtensions}: {main: number, hasSubExtensions: boolean}) {

    const {data: extensions, isFetching, fetchNextPage} = useGetExtensionsInfiniteQuery({
        parent: main
    }, {
        skip: !hasSubExtensions,
    })

    const refInfinity = useRefInfinity(fetchNextPage, extensions);

    if(!hasSubExtensions) {
        return (
            <div className="p-4 text-gray-400 flex justify-center items-center">
                אין לך עדיין שלוחות
            </div>
        )
    }

    if(!extensions) return (
        <div className="p-4 flex justify-center items-center">
            <Spinner size="lg"/>
        </div>
    );

    if(extensions.pages[0].count === 0) {
        return (
            <div className="p-4 text-gray-400 flex justify-center items-center">
                אין לך עדיין שלוחות
            </div>
        )
    }

    return (
        <div>
            {extensions.pages.map(p => p.results.map((extension) => (
                <ExtensionCard  {...extension} key={extension.id} isDeepSub />
            )))}

            <div ref={refInfinity} className={cn(isFetching && "p-4 flex justify-center items-center")}>
                {isFetching && (
                    <Spinner />
                )}
            </div>
        </div>
    )
}